import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.LIST,
    '/api/v1/administrators/transaction_histories',
    payload,
    callback
  );

export const getItem = (id, payload, callback) =>
  req.item(
    c.ITEM,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );
